// utils/otp.ts
import { saveAuthSession } from '@/utils/profile/authSession';

export const convertToEnglishDigits = (str: string): string =>
    str.replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)));

export const verifyOtp = async ({
    otp,
    onVerify,
    onSuccess,
    setError,
    toast,
    inputRefs,
    resetSubmitted,
}: {
    otp: string;
    onVerify: (otp: string) => Promise<{ token: string; success: boolean; message: string }>;
    onSuccess: () => void;
    setError: (msg: string | null) => void;
    toast: any;
    inputRefs: Array<HTMLInputElement | null>;
    resetSubmitted?: () => void;
}) => {
    try {
        const { token, message, success } = await onVerify(otp);
        if (success) {
            // Already saved with the refresh token by handleVerifyOtp; keep the access token in sync.
            saveAuthSession(token);
            onSuccess();
            toast({
                title: message,
                duration: 5000,
                className: 'bg-green-500 bg-opacity-95 text-white rounded-2xl border-0',
            });
        } else {
            inputRefs[3]?.focus();
            toast({
                title: message || 'کد وارد شده معتبر نمی‌باشد.',
                duration: 5000,
                className: 'bg-red-500 text-white rounded-2xl border-0',
            });
        }
    } catch (error: any) {
        inputRefs[3]?.focus();
        const errorMessage = error?.response?.data?.message || 'OTP verification failed.';
        setError(errorMessage);
        toast({
            title: errorMessage,
            duration: 5000,
            className: 'bg-red-500 text-white rounded-2xl border-0',
        });
    } finally {
        resetSubmitted?.(); // 👈 always allow new input again
    }
};

// utils/otp.ts
export const resendOtpHandler = (
    retryTime: number,
    setError: (msg: string | null) => void,
    onRetry?: () => void,
    setOtpDigits?: (digits: string[]) => void,
) => {
    if (retryTime > 0) {
        setError(`Please wait ${retryTime}s before retrying.`);
    } else {
        setError(null);
        setOtpDigits?.(['', '', '', '']);
        onRetry?.();
    }
};
